import React, { StrictMode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Loader from './components/Loader';
import { Main } from './Main';

import './App.css';

function App() {
  return (
    // <StrictMode>
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <Main />
      </Provider>
    </Suspense>
    // </StrictMode>
  );
}

export default App;
